import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlask, faHospital, faBrain, faDumbbell } from '@fortawesome/free-solid-svg-icons';
import '../assets/styles/Research.scss';

function Research() {
  return (
    <div className="container" id="research">
      <div className="research-container">
      <h1 className="research-title">
          <FontAwesomeIcon icon={faFlask} className="title-icon" />
          Research & Clinical Experience
        </h1>
        <div className="research-grid">
          <div className="research-item dissertation">
            <FontAwesomeIcon icon={faFlask} size="3x"/>
            <h3>Postgraduate Dissertation</h3>
            <h4>"Anxiety in Cancer Patients"</h4>
            <p className="institution">KLE Dr. Prabhakar Kore Hospital, Belgaum</p>
            <p>
              Conducted a descriptive research study examining anxiety levels in cancer patients. 
              This research was completed under the guidance of Dr. Yasmin Nadaf (HOD, Psychology) 
              and Dr. Shivaswamy (HOD, Community Medicine), combining clinical psychology principles 
              with quantitative research methods.
            </p>
            <div className="research-tags">
              <span>Quantitative Research</span>
              <span>Clinical Psychology</span>
              <span>SPSS Analysis</span>
            </div>
          </div>

          <div className="research-item">
            <FontAwesomeIcon icon={faHospital} size="3x"/>
            <h3>Clinical Internship</h3>
            <h4>KLE Dr. Prabhakar Kore Hospital & MRC</h4>
            <p className="duration">3 months | Belgaum, India</p>
            <p>
              Observed various therapeutic interventions including individual psychotherapy, group therapy, 
              and couple therapy. Conducted psychological assessments including TAT, CAT, and anxiety tests, 
              gaining hands-on experience in clinical assessment and therapeutic techniques.
            </p>
            <div className="research-tags">
              <span>Psychotherapy</span>
              <span>Psychometric Testing</span>
              <span>Clinical Assessment</span>
            </div>
          </div>

          <div className="research-item">
            <FontAwesomeIcon icon={faBrain} size="3x"/>
            <h3>Mental Health Internship</h3>
            <h4>Chaitanya Institute for Mental Health</h4>
            <p className="duration">3 months | Pune, India</p>
            <p>
              Observed various mental illness and addiction cases, developing expertise in differential 
              diagnosis and treatment approaches. Conducted MMSE (Mini-Mental State Examination) for 
              dementia, psychotic, and neurotic patients, building foundational skills in clinical evaluation.
            </p>
            <div className="research-tags">
              <span>Mental Health</span>
              <span>MMSE Assessment</span>
              <span>Clinical Observation</span>
            </div>
          </div>

          <div className="research-item">
            <FontAwesomeIcon icon={faDumbbell} size="3x"/>
            <h3>Sports Psychology Consultant</h3>
            <h4>Arise Physiotherapy Center</h4>
            <p className="duration">1 year (Part-time) | Belgaum, India</p>
            <p>
              Counseled school and college athletes dealing with performance anxiety, stress, and depression. 
              Conducted relaxation sessions and group therapy programs, applying psychological principles 
              to enhance athletic performance and mental well-being.
            </p>
            <div className="research-tags">
              <span>Sports Psychology</span>
              <span>Performance Counseling</span>
              <span>Group Therapy</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Research;